// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./loadingSpinner.scss');

const deps = [];

module.exports = angular
  .module('bench.ui.loadingSpinner', deps)

  .directive('blLoadingSpinner', () => ({
    restrict: 'E',
    scope: {},
    template: require('./loadingSpinner.html'),
  }));
